import * as v from "valibot";
import { specialCharRegex } from "helpers/password";

import { rpcContract } from "../rpc";

const createFanAccountParamsSchema = v.object({
  email: v.pipe(v.string(), v.email("Invalid email address")),
  password: v.pipe(
    v.string(),
    v.minLength(8, "Password must be at least 8 characters"),
    v.maxLength(64, "Password cannot exceed 64 characters"),
    v.regex(/[A-Z]/, "Password must contain at least one uppercase letter"),
    v.regex(/[a-z]/, "Password must contain at least one lowercase letter"),
    v.regex(/\d/, "Password must contain at least one number"),
    v.regex(specialCharRegex, "Password must contain at least one special character"),
  ),
  firstName: v.pipe(
    v.string(),
    v.minLength(1, "First name is required"),
    v.maxLength(50, "First name cannot exceed 50 characters"),
  ),
  lastName: v.pipe(
    v.string(),
    v.minLength(1, "Last name is required"),
    v.maxLength(50, "Last name cannot exceed 50 characters"),
  ),
});

const createFanAccountResultSchema = v.object({
  user: v.object({
    id: v.string(),
    email: v.string(),
    name: v.string(),
  }),
  authToken: v.string(),
  sessionToken: v.string(),
});

export type CreateFanAccountParams = v.InferInput<typeof createFanAccountParamsSchema>;
export type CreateFanAccountResult = v.InferOutput<typeof createFanAccountResultSchema>;

export const createFanAccountRpcContract = rpcContract({
  name: "create-fan-account",
  paramsSchema: createFanAccountParamsSchema,
  resultSchema: createFanAccountResultSchema,
});
